import { render, staticRenderFns } from "./CollectionFollowResultPerformance.vue?vue&type=template&id=bbf21fba&scoped=true"
import script from "./CollectionFollowResultPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionFollowResultPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionFollowResultPerformance.vue?vue&type=style&index=0&id=bbf21fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf21fba",
  null
  
)

export default component.exports